import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Monitoring from './pages/Monitoring';
import Inspeksi from './pages/Inspeksi';
import Temuan from './pages/Temuan';
import Laporan from './pages/Laporan';
import Users from './pages/Users';
import Apar from './pages/Apar';
import PetaGapCoverage from './pages/PetaGapCoverage';
import Database from './pages/Database';
import PublicKartuApar from './pages/PublicKartuApar';

function PrivateRoute({ children }) {
  const { user, isLoading } = useAuth();
  if (isLoading) return <div className="flex items-center justify-center h-screen"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div></div>;
  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<PrivateRoute><Layout><Dashboard /></Layout></PrivateRoute>} />
          <Route path="/monitoring" element={<PrivateRoute><Layout><Monitoring /></Layout></PrivateRoute>} />
          <Route path="/database" element={<PrivateRoute><Layout><Database /></Layout></PrivateRoute>} />
          <Route path="/apar" element={<PrivateRoute><Layout><Apar /></Layout></PrivateRoute>} />
          <Route path="/peta-apar" element={<PrivateRoute><Layout><PetaGapCoverage /></Layout></PrivateRoute>} />
          <Route path="/users" element={<PrivateRoute><Layout><Users /></Layout></PrivateRoute>} />
          <Route path="/laporan" element={<PrivateRoute><Layout><Laporan /></Layout></PrivateRoute>} />
          <Route path="/temuan" element={<PrivateRoute><Layout><Temuan /></Layout></PrivateRoute>} />
          <Route path="/inspeksi" element={<PrivateRoute><Layout><Inspeksi /></Layout></PrivateRoute>} />
          <Route path="/apar/:giId/:aparId" element={<PublicKartuApar />} />
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
